import { installNetworkPerformanceTrace, markPerformance } from "./services/performanceTrace";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./zuno-premium.css";
import "./ios-passenger-theme.css";
import "leaflet/dist/leaflet.css";
import App from "./App";
import { initializeTheme, ThemeProvider } from "./theme/ThemeContext";
import { AccessibilityProvider, initializeAccessibility } from "./accessibility/AccessibilityContext";
import AppErrorBoundary from "./components/AppErrorBoundary";
import { initializeStoreScreenshotSession } from "./screenshotSession";
import { Capacitor } from "@capacitor/core";
import { installMapAuthDiagnostic } from "./services/mapDiagnostics";

markPerformance("JS_LOADED", {}, { onlyOnce: true });
installNetworkPerformanceTrace();

document.documentElement.dataset.zunoNative = String(Capacitor.isNativePlatform());
document.documentElement.dataset.zunoPlatform = Capacitor.getPlatform();

installMapAuthDiagnostic();

initializeTheme();
initializeAccessibility();

// ✅ Suprime AbortError de Promises (Google Maps cancela requests ao desmontar)
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  if (!error) return;
  const msg = (error.message || "").toLowerCase();
  if (
    error.name === 'AbortError' ||
    msg.includes('aborted') ||
    msg.includes('abort') ||
    msg.includes('the user aborted')
  ) {
    event.preventDefault();
  }
});

// ✅ Remove o overlay vermelho do react-scripts que aparece em modo dev
if (process.env.NODE_ENV === 'development') {
  const removeOverlay = () => {
    // Remove iframe do webpack overlay
    const iframe = document.querySelector('iframe#webpack-dev-server-client-overlay');
    if (iframe) iframe.remove();

    // Remove divs de erro do React runtime error overlay
    document.querySelectorAll('body > div').forEach((div) => {
      if (
        div.shadowRoot ||
        (div.style.position === 'fixed' && div.innerHTML.includes('aborted'))
      ) {
        div.remove();
      }
    });
  };

  // Observa o DOM para remover o overlay assim que aparecer
  const observer = new MutationObserver(removeOverlay);
  observer.observe(document.body, { childList: true, subtree: false });

  // Também tenta remover ao carregar
  window.addEventListener('load', removeOverlay);
}

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Elemento root não encontrado");
}

const renderApp = () => {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <AppErrorBoundary>
      <ThemeProvider>
        <AccessibilityProvider>
          <App />
        </AccessibilityProvider>
      </ThemeProvider>
    </AppErrorBoundary>
  );
  window.requestAnimationFrame(() => markPerformance("FIRST_SCREEN_RENDER", {
    splashVisibleMs: Math.round(performance.now()),
  }, { onlyOnce: true }));
};

initializeStoreScreenshotSession()
  .catch((error) => console.error("[StoreScreenshots] Session bootstrap failed", { code: error?.code || error?.message || "unknown" }))
  .finally(renderApp);
